import { QuestionTypeContent } from "./QuestionTypeContent";
export default QuestionTypeContent;
